// src/features/auth/signup/TermsCheckbox.jsx
import React, { useState } from 'react';
import LegalTermsModal from '../../legal/LegalTermsModal';

const TermsCheckbox = ({ register, errors, setValue }) => {
    const [showTermsModal, setShowTermsModal] = useState(false);

    const handleAcceptFromModal = () => {
        setValue('terms', true, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    };

    return (
        <div className="col-span-2">
            <div className="flex items-start">
                <input
                    id="terms"
                    type="checkbox"
                    className="w-4 h-4 mt-0.5 text-brand-500 border-surface-300 dark:border-surface-600 rounded focus:ring-brand-500"
                    {...register('terms', { required: 'Debes aceptar los términos y condiciones' })}
                />
                <label htmlFor="terms" className="ml-2 text-sm text-surface-500 dark:text-surface-400 leading-relaxed">
                    Acepto los{' '}
                    <button
                        type="button"
                        onClick={() => setShowTermsModal(true)}
                        className="text-brand-500 hover:text-brand-400 font-medium transition-colors"
                    >
                        términos y condiciones
                    </button>
                    .
                </label>
            </div>
            {errors.terms && <span className="text-red-500 text-xs mt-1 block">{errors.terms.message}</span>}

            <LegalTermsModal
                isOpen={showTermsModal}
                onClose={() => setShowTermsModal(false)}
                onAccept={handleAcceptFromModal}
                showCloseButton={true}
                persistOnAccept={false}
                title="Terminos y Condiciones para Registro"
            />
        </div>
    );
};

export default TermsCheckbox;
